import './QRDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SplitButton } from 'primereact/splitbutton';
import QRCode from 'qrcode.react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TransportEntitiesType } from '../TransportEntities.functions';
import { getDownloadButtonItems } from './QRDialog.functions';

type Props = {
  data: TransportEntitiesType | null;
  isShown: boolean;
  onHide: () => void;
};

function QRDialog({ data, isShown, onHide }: Props) {
  const { t } = useTranslation();

  const dialogFooter = (
    <Button type="button" label="Close" onClick={onHide} data-cy="close-btn" />
  );

  const downloadButtonItems = useMemo(
    () => getDownloadButtonItems(t, data),
    [data, t]
  );

  return (
    <Dialog
      visible={isShown}
      onHide={onHide}
      header={t('QR Code')}
      footer={dialogFooter}
      dismissableMask
      resizable={false}
      className="transport-entities-qr-dialog"
    >
      <div className="info-item">
        <h4>{t('Transport entity type')}</h4>
        <span>{data?.transportEntityType?.name}</span>
      </div>

      <div className="info-item">
        <h4>{t('Barcode')}</h4>
        <span>{data?.barcode}</span>
      </div>

      {isShown && (
        <>
          <h4>{t('QR Code')}</h4>
          <QRCode
            value={data?.barcode ?? ''}
            level="L"
            size={256}
            className="qr-code"
          />
        </>
      )}

      <div className="p-mt-2 p-text-center">
        <SplitButton
          label={t('Download')}
          model={downloadButtonItems}
          onClick={downloadButtonItems[0].command}
          className="p-button-secondary"
        />
      </div>
    </Dialog>
  );
}

export default QRDialog;
